import { Avatar } from '@mui/material'
import { useSelector } from '../../redux/hooks/useSelector'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { TransparentIconButton } from '../common/TransparentIconButton'
import { logout } from '../../services/keycloak.service'
import store from '../../redux/store'
import { isClientUser } from '../../services/keycloak.service'
import { LogoutRounded as Logout, PaletteRounded as Palette } from '@mui/icons-material'
import { tokens } from '../../styles/tokens'
import { useThemeMode, nextThemeModeLabelKey } from '../../contexts/ThemeModeContext'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 1),
    borderTop: `1px solid ${tokens.color.neutral[200]}`,
    boxSizing: 'border-box',
  },
  avatar: {
    height: '2rem',
    width: '2rem',
    flexShrink: 0,
  },
  info: {
    flexGrow: 1,
    minWidth: 0,
  },
  title: {
    fontSize: '1rem',
    fontWeight: tokens.font.weight.semibold,
    letterSpacing: '-0.01em',
    color: tokens.color.neutral[900],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  subtitle: {
    fontSize: '0.75rem',
    color: tokens.color.neutral[500],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  text: {
    margin: 0,
  },
}))

const User = () => {
  const classes = useStyles()
  const user = useSelector(state => state.auth.user)
  const client = useSelector(state => state.clients.client)
  const { t } = useTranslation()
  const { mode, toggleThemeMode } = useThemeMode()

  let name, symbols

  if (!isClientUser()) {
    name = `${user?.firstName} ${user?.lastName}`
    symbols = user?.firstName.charAt(0).toUpperCase() + user?.lastName.charAt(0).toUpperCase()
  } else {
    name = `${client?.firstName} ${client?.surname}`
    if (!!client.firstName) {
      symbols = client?.firstName.charAt(0).toUpperCase() + client?.surname.charAt(0).toUpperCase()
    }
  }

  return (
    <span>
      <div className={classes.wrapper}>
        <Avatar className={classes.avatar}>{symbols}</Avatar>
        <span className={classes.info}>
          <p className={classNames(classes.text, classes.title)}>{name}</p>
        </span>
        <div title={t(nextThemeModeLabelKey[mode])}>
          <TransparentIconButton onClick={toggleThemeMode} icon={<Palette />} />
        </div>
        <div title={t('LOG_OUT')}>
          <TransparentIconButton
            onClick={() => {
              logout(store)
            }}
            icon={<Logout />}
          />
        </div>
      </div>
    </span>
  )
}

export default User
